import { render } from "./app.vue?vue&type=template&id=5323f7b6&ts=true"
import script from "./app.component.ts?vue&type=script&lang=ts"
export * from "./app.component.ts?vue&type=script&lang=ts"

import exportComponent from "G:\\Projects\\Kml\\KmlAuth\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__